<!--
 * @Author: zhaoliang
 * @Date: 2024-06-27 16:38:46
 * @LastEditTime: 2026-01-28 18:23:44
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/EnquiryForm/FileUpload.vue
 *
-->
<template>
  <div class="file-upload-container">
    <div class="file-list" v-for="(file, index) in fileList" :key="index">
      <img v-if="isPdf(file)" src="~img/icon-pdf.svg" alt="" />
      <img v-else-if="isDoc(file)" src="~img/icon-doc.svg" alt="" />
      <img v-else src="~img/icon-pic.svg" alt="" />
      <div class="file-list-desc">
        <p>{{ file.name }}</p>
      </div>
      <img @click="fileDelete(file, index)" src="~img/icon-delete.svg" alt="" />
    </div>
    <div class="file-upload" v-if="fileList.length < 3" @click="$refs.fileUpload.click()">
      <img src="~img/icon-attachment.svg" alt="" />
      <div class="file-upload-desc">
        <p>{{ $t('freshdesk-upload-tips1') }}</p>
        <p>{{ $t('freshdesk-upload-tips2') }}</p>
        <p>{{ $t('freshdesk-upload-tips3') }}</p>
      </div>
    </div>
    <input
      ref="fileUpload"
      type="file"
      :accept="acceptFileType"
      @change="fileChange"
      style="display: none"
    />
  </div>
</template>
<script>
  import imageCompression from 'browser-image-compression';
  import { BlockBlobClient, AnonymousCredential } from '@azure/storage-blob';
  // import { v4 as uuidv4 } from 'uuid';

  export default {
    name: 'FileUpload',
    data() {
      return {
        fileList: [],
        uploadEndPoint: '',
      };
    },
    emits: ['update:modelValue', 'change'],
    props: {
      modelValue: {
        type: Array,
        default: () => [],
      },
      acceptFileType: {
        type: String,
        default: '.pdf, .doc, .docx, .jpg, .jpeg, .png, .gif, .bmp, .heif, .webp, .raw, .tiff',
      },
    },
    watch: {
      modelValue: {
        handler(val) {
          this.fileList = val;
        },
        immediate: true,
      },
    },
    mounted() {
      this.getUploadConfig();
    },
    methods: {
      emitChange(fileList) {
        this.$emit('update:modelValue', fileList);
        this.$emit('change', fileList);
      },
      async fileChange(e) {
        const file = e.target.files[0];
        if (!file) return;

        const fileSize = file.size / 1024 / 1024;
        let tempFileList = [];

        if (fileSize > 5) {
          // 超过5mb不上传
          tempFileList = [...this.fileList, file];
        } else {
          const newFile = await this.uploadFile(file);
          if (!newFile) return;
          tempFileList = [...this.fileList, newFile];
        }
        this.emitChange(tempFileList);
      },
      fileDelete(file, index) {
        const tempFileList = [...this.fileList];
        tempFileList.splice(index, 1);
        this.emitChange(tempFileList);
      },
      isPdf(file) {
        const fileType = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
        return ['pdf'].includes(fileType);
      },
      isDoc(file) {
        const fileType = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
        return ['doc', 'docx'].includes(fileType);
      },
      isPic(file) {
        const fileType = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
        return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'heif', 'webp', 'raw', 'tiff'].includes(
          fileType,
        );
      },
      getUploadConfig() {
        this.$http.common.getUploadConfig().then(res => {
          if (res.state === '11') {
            this.uploadEndPoint = res.data.endPoint;
          }
        });
      },
      async compressedPic(file) {
        const isPic = this.isPic(file);
        if (isPic) {
          const newPic = await imageCompression(file, {
            // maxSizeMB: 1,
            // maxWidthOrHeight: 1920,
            maxIteration: 30,
            useWebWorker: true,
            onProgress: p => {
              console.log('onProgress', p);
            },
          });
          return newPic;
        }
        return file;
      },
      async azureSasToken(fileName) {
        const res = await this.$http.common.generateSasToken({ fileName });
        return res;
      },
      async uploadFile(file) {
        const compressedFile = await this.compressedPic(file);
        // const fileExt = file.name.substring(file.name.lastIndexOf('.') + 1);
        // const blobName = `${uuidv4()}.${fileExt}`;
        // 获取SAS Token并上传
        const res = await this.azureSasToken(file.name);
        if (res.state === '11' && res.data && this.uploadEndPoint) {
          const { sasToken, fileName } = res.data;
          const login = `${this.uploadEndPoint}/${fileName}?${sasToken}`;
          const blockBlobClient = new BlockBlobClient(login, new AnonymousCredential());
          try {
            const result = await blockBlobClient.uploadData(compressedFile);
            console.log(result);
            this.$refs.fileUpload.value = null;
            return {
              size: file.size,
              name: file.name,
              blobName: fileName,
            };
          } catch (err) {
            // azure上传失败
            console.log(err);
            return null;
          }
        }
        return null;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .file-upload-container {
    position: relative;

    @include font(16px, 400);

    .file-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 10px 0;
      padding: 10px;
      border-radius: 10px;
      background-color: #f5f7f8;

      img:first-child {
        width: 30px;
        height: 30px;
        object-fit: cover;
      }

      .file-list-desc {
        flex: 1;
        padding: 0 20px;
        @include font(18px, 600);

        p {
          overflow-wrap: anywhere;
          line-height: 1.2;
        }
      }

      img:last-child {
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }

    .file-upload {
      cursor: pointer;
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      background-color: #f5f7f8;
      border-radius: 10px;
      border: 1px dotted #7f898f;
      padding: 0 10px;
      box-sizing: border-box;

      img {
        width: 50px;
        height: 40px;
      }

      .file-upload-desc {
        margin-left: 20px;

        p:first-child {
          @include font(20px, 400);
        }

        p:nth-child(2) {
          margin: 5px 0;
        }

        // p:last-child {
        //   color: #7f898f;
        // }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .file-upload-container {
      @include font(12px, 400);

      .file-list {
        margin: 10px 0;
        padding: 10px;

        img:first-child {
          width: 20px;
          height: 20px;
        }

        .file-list-desc {
          padding-left: 16px;
          @include font(14px, 600);
        }

        img:last-child {
          width: 12px;
          height: 12px;
        }
      }

      .file-upload {
        width: 100%;
        height: 78px;
        padding: 0 10px;

        img {
          width: 40px;
          height: 30px;
        }

        .file-upload-desc {
          margin-left: 10px;

          p:first-child {
            @include font(14px, 400);
          }

          p:nth-child(2) {
            margin: 5px 0;
          }

          // p:last-child {
          //   color: #7f898f;
          // }
        }
      }
    }
  }
</style>
